import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const COPY = {
  en: {
    TITLE: 'Account pending approval',
    BODY: 'Your details are saved. Contact us on WhatsApp and we will activate your workspace shortly.',
    CTA: 'Contact on WhatsApp',
    EMAIL_CTA: 'Email support',
    LOGOUT: 'Log out',
  },
  zh_CN: {
    TITLE: '账号待审核',
    BODY: '资料已提交。请通过 WhatsApp 联系我们，我们将尽快开通您的工作区。',
    CTA: '通过 WhatsApp 联系',
    EMAIL_CTA: '发送邮件',
    LOGOUT: '退出登录',
  },
};

const pickLocalePack = locale => {
  if (!locale) return COPY.en;
  if (COPY[locale]) return COPY[locale];
  if (locale.startsWith('zh')) return COPY.zh_CN;
  return COPY.en;
};

const resolveMessage = (t, fullKey, fallbackText) => {
  const translated = t(fullKey);
  if (
    !translated ||
    translated === fullKey ||
    translated.startsWith('REGISTRATION_GATE.')
  ) {
    return fallbackText;
  }
  return translated;
};

export function useRegistrationGateCopy() {
  const { t, locale } = useI18n();

  const fallback = computed(() => pickLocalePack(locale.value));

  const title = computed(() =>
    resolveMessage(t, 'REGISTRATION_GATE.TITLE', fallback.value.TITLE)
  );
  const body = computed(() =>
    resolveMessage(t, 'REGISTRATION_GATE.BODY', fallback.value.BODY)
  );
  const cta = computed(() =>
    resolveMessage(t, 'REGISTRATION_GATE.CTA', fallback.value.CTA)
  );
  const emailCta = computed(() =>
    resolveMessage(t, 'REGISTRATION_GATE.EMAIL_CTA', fallback.value.EMAIL_CTA)
  );
  const logout = computed(() =>
    resolveMessage(t, 'REGISTRATION_GATE.LOGOUT', fallback.value.LOGOUT)
  );

  return { title, body, cta, emailCta, logout };
}
